import ButtonUnstyled, { ButtonUnstyledProps } from '@mui/base/ButtonUnstyled';
import * as React from 'react';
import './index.scss';

export const Button: React.FC<ButtonUnstyledProps> = ({
  className,
  ...props
}) => <ButtonUnstyled {...props} className={['Button', className].join(' ')} />;
